const Tracking = () => {
    return (
      <div>
      
      <div className="flex flex-col justify-center  gap-1 max-w-[50rem] mx-auto pl-[2rem] pr-[2rem] pt-[1rem]">
        <h1 className="text-[20px] font-bold">Tracking</h1>
        <p>
          Whether you intend to move instruments for an orchestral performance or digital equipment for larger 
          than life installations, TCS provides end-to-end inbound and outbound tracking services from the point 
          of origin to the venue of the event. This helps to identify the real time location and other critical 
          conditions of in-transit cargo that may be of a customer’s concern.
        </p>
       
  
       
      </div>
    </div>  
    );
  };
    
  export default Tracking;